export type TagSegment = {
  text: string
  strong: boolean
}

export const splitTagBySubstrings = (tagText: string, strongText?: string[]): TagSegment[] => {
  if (!strongText || strongText.length === 0) {
    return [{ text: tagText, strong: false }]
  }

  return strongText.reduce<TagSegment[]>(
    (segments, substring) =>
      segments.flatMap((segment) => {
        if (segment.strong) {
          return [segment]
        }

        const index = substring ? segment.text.indexOf(substring) : -1
        if (index === -1) {
          return [segment]
        }

        const before = segment.text.slice(0, index)
        const match = segment.text.slice(index, index + substring.length)
        const after = segment.text.slice(index + substring.length)

        return [
          ...(before ? [{ text: before, strong: false }] : []),
          { text: match, strong: true },
          ...(after ? [{ text: after, strong: false }] : []),
        ]
      }),
    [{ text: tagText, strong: false }],
  )
}
